import colorScheme from './colorScheme';
import fontScheme from './fontScheme';
import formatScheme from './formatScheme';
var themeElements = {
    getTemplate: function () {
        return {
            name: "a:themeElements",
            children: [
                colorScheme.getTemplate(),
                fontScheme.getTemplate(),
                formatScheme.getTemplate()
            ]
        };
    }
};
export default themeElements;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/excel-export/dist/es6/excelExport/files/ooxml/themes/office/themeElements.js
// module id = 3147
// module chunks = 0